import { FeatureFlagScope } from './FeatureFlagScope.js';

const DefaultFeatureFlags = FeatureFlagScope.create();

export { DefaultFeatureFlags };
